/* ==================================================================================================
   ALL PRODUCT REVIEWS — behaviour for sections/all-product-reviews.liquid.

   Held in an asset rather than inline in the section, matching shop-the-stack.js, will-it-fit.js and
   shop-by-ear-stack-inspiration.js. Everything is scoped to a section root, so several instances on
   one page each get their own listeners and neither reaches into the other.

   Nothing here is required for the reviews to be readable: without it every review renders, clamped
   to five lines, and the row still scrolls by swipe. The script adds only the Read more reveal on
   top of that.

   There is deliberately NO pager. The row is swiped or scrolled and the peek of the next card is
   what says so, so scroll position is never tracked and nothing here listens to the list at all.
   ================================================================================================== */

(function () {
  'use strict';

  /* The section emits one <script src> per instance. Two instances would therefore run this file
     twice, re-binding every listener. Binding is per root and guarded by a flag on the element, so a
     second run finds nothing left to do. */
  function setupRoot(root) {
    if (!root || root.dataset.aprReady === 'true') {
      return;
    }

    root.dataset.aprReady = 'true';

    /* READ MORE. The button starts hidden on every card and is revealed only where the text is
       actually overflowing its clamp — scrollHeight against clientHeight is exact, per card, at
       whatever width the card happens to be.

       That is measured rather than guessed from a character count because a guess cannot be right at
       both breakpoints: the same review wraps to more lines in a 280px mobile card than in a 290px
       desktop one, so a count shows a dead control on some cards and withholds it on others.

       A card the customer has already expanded is skipped, or the measurement would re-hide the
       button that is currently reading "View less". */
    function syncMoreButtons() {
      root.querySelectorAll('.apr__card').forEach(function (card) {
        var text = card.querySelector('[data-apr-text]');
        var button = card.querySelector('[data-apr-more]');

        if (!text || !button || button.getAttribute('aria-expanded') === 'true') {
          return;
        }

        button.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-apr-more]');

      if (!button) {
        return;
      }

      var card = button.closest('.apr__card');
      var text = card && card.querySelector('[data-apr-text]');

      if (!text) {
        return;
      }

      var expanded = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      text.classList.toggle('apr__text--clamped', expanded);
      button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
    });

    syncMoreButtons();

    /* Re-measured on resize because the same review wraps to a different number of lines at a
       different card width, so a button that was dead at one width can be needed at another. */
    window.addEventListener('resize', syncMoreButtons);

    /* The images are lazy-loaded and the cards are stretched to equal heights, so a picture arriving
       after first paint changes the height the clamp is measured against. */
    window.addEventListener('load', syncMoreButtons);
  }

  function setupAll() {
    document.querySelectorAll('[data-section-type="all-product-reviews"]').forEach(setupRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  /* The theme editor re-renders a section in place without a page load. The new DOM carries no
     aprReady flag, so setupRoot binds it exactly as it would on a fresh page. */
  document.addEventListener('shopify:section:load', setupAll);
})();
